import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Disclosure, Transition } from '@headlessui/react';
import type { JSX } from 'react';
import { memo, PropsWithChildren } from 'react';

import { Color } from '@/constants/color';
import { Props } from '@/ui/components/Accordion/types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Accordion = ({
  additionalButtonContent,
  buttonAriaLabel,
  buttonIconClosed = faChevronDown,
  buttonIconOpen = faChevronUp,
  buttonColor = Color.GRAY,
  buttonText,
  contentBackground = 'bg-white',
  children,
  defaultOpen = false,
  className = '',
  iconClassName = '',
  onClick
}: PropsWithChildren<Props>): JSX.Element => {
  const colorClasses = `border-${buttonColor}-200 bg-${buttonColor}-50 text-${buttonColor}-900 hover:bg-${buttonColor}-200 focus:outline-hidden focus-visible:ring-3 focus-visible:ring-${buttonColor}-500`;

  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <Disclosure.Button
            aria-label={buttonAriaLabel}
            className={`${
              open ? 'rounded-t-lg' : 'rounded-lg shadow-xs'
            } ${colorClasses} ${className} border w-full items-center px-3 py-2 text-left font-medium focus-visible:ring-opacity-75`}
            {...(onClick && { onClick: onClick })}>
            <span className="flex w-full justify-between items-center">
              <span className="font-bold flex-1">{buttonText}</span>
              <FontAwesomeIcon
                className={`transform h-4 w-4 text-gray-500 mr-2 ${iconClassName}`}
                icon={open ? buttonIconOpen : buttonIconClosed}
              />
            </span>

            {additionalButtonContent && <span>{additionalButtonContent}</span>}
          </Disclosure.Button>

          <Transition
            show={open}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0">
            <Disclosure.Panel
              static
              className={`${contentBackground} shadow-sm rounded-b-lg p-3 sm:p-2`}>
              {children}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

export default memo(Accordion);
